import React, { useState, useRef, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { getImage } from '../../utils/FileHelper';
import { defaultUrl, getAccessToken } from '../../http';
import { usePdf } from '../../utils/PdfViewer';

const streamUrl = id => `/resource/v1/resources/file/${id}/stream`;

const ResourcePdfPage = ({ id }) => {
	const [page, setPage] = useState(1);
	const canvasRef = useRef(null);

	const { pdfDocument, pdfPage } = usePdf({
		file: defaultUrl + streamUrl(id),
		page,
		canvasRef,
		withCredentials: true,
		httpHeaders: { Authorization: 'Bearer ' + getAccessToken() },
	});

	return (
		<div>
			{!pdfDocument && <span>Loading...</span>}
			<canvas ref={canvasRef} />
			{Boolean(pdfDocument && pdfDocument.numPages) && (
				<nav>
					<ul className="pager">
						<li className="previous">
							<button disabled={page === 1} onClick={() => setPage(page - 1)}>
								Previous
							</button>
						</li>
						<li className="next">
							<button disabled={page === pdfDocument.numPages} onClick={() => setPage(page + 1)}>
								Next
							</button>
						</li>
					</ul>
				</nav>
			)}
		</div>
	);
};

const ResourcePdfViewer = () => {
	const [pdfUrl, setPdfUrl] = useState(null);
	let { pdfId } = useParams();

	useEffect(() => {
		getImage({ id: pdfId, resourceId: pdfId, setImgUrl: setPdfUrl });
	}, [pdfId]);

	if (!pdfUrl) {
		return <div>Loading PDF</div>;
	}

	return <ResourcePdfPage id={pdfId} />;
};

export default ResourcePdfViewer;
